const GameOverMessage: React.FC = (): JSX.Element => {
  return <p className="text-white font-prime text-sm text-center mb-1 mx-auto">Game Over!</p>;
};

export default GameOverMessage;
